<template>
  <sidebar-icon :inputIconPath="path" :selected="selected()" routerPath="/setting" />
</template>

<script>
import SidebarIcon from "./sidebar-icon.vue"

export default {
  data() {
      return {
          width: window.innerWidth,
          path: "setting_icon_selected.svg",
      };
  },
  mounted() {
      // load icon path
      this.getPath(this.width)
      
      window.addEventListener("resize", () => {
          this.width = window.innerWidth;
      });
  },
  methods: {
      selected() {
          return this.$route.fullPath == "/setting";
      }, 
      getPath() {
          this.path = this.selected() ? "setting_icon_selected.svg" : "setting_icon.svg";
      },
  },
  components: { SidebarIcon }
};
</script>

<style scoped>

</style>
